import {
  View,
  Text,
  Keyboard,
  TouchableOpacity,
  StyleSheet,
  Image,
  TextInput,
} from "react-native";
import React, { useState } from "react";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import CommonTextInput from "../../../common/CommonTextInput";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { AppImages } from "../../../utility/AppImages";
import OTPTextView from "react-native-otp-textinput";
import { AppScreens } from "../../Utility/AppScreens";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../Api/configs";
import { ShowLoader } from "../../../common/ShowLoader";
import { resetPassword } from "../../../services/authAPI";
import { ScreenBGGradientView } from "../../../common/CommonView";

// Country codes list
const countryCodes = [
  { code: '+1', country: 'US/CA' },
  { code: '+44', country: 'UK' },
  { code: '+91', country: 'IN' },
  { code: '+61', country: 'AU' },
  { code: '+86', country: 'CN' },
  { code: '+81', country: 'JP' },
  { code: '+49', country: 'DE' },
  { code: '+33', country: 'FR' },
  { code: '+39', country: 'IT' },
  { code: '+34', country: 'ES' },
  { code: '+7', country: 'RU' },
  { code: '+55', country: 'BR' },
  { code: '+52', country: 'MX' },
  { code: '+82', country: 'KR' },
  { code: '+65', country: 'SG' },
  { code: '+971', country: 'AE' },
  { code: '+966', country: 'SA' },
  { code: '+27', country: 'ZA' },
  { code: '+234', country: 'NG' },
  { code: '+254', country: 'KE' },
];

const ResetPasswordWebScreen = () => {
  const navigation = useNavigation();
  const [otpInput, setOtpInput] = useState("");
  const [username, setUsername] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [authType, setAuthType] = useState<'email' | 'phone'>('email');
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      <View
        style={{
          ...(deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG
            ? { flex: 1, justifyContent: "flex-start" }
            : { flex: 0.4, justifyContent: "center" }),
        }}
      >
        {deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG ? (
          <View style={{ alignItems: "center", marginTop: 10 }}>
            <View
              style={{
                borderRadius: 12,
                width: "90%",
                maxWidth: 380,
                height: 260,
                elevation: 20,
              }}
            >
              <Image
                source={AppImages.icMainLogo}
                style={{
                  resizeMode: "contain",
                  width: "100%",
                  height: "100%",
                }}
              />
            </View>
          </View>
        ) : null}
        <View
          style={{
            paddingLeft:
              deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                ? "5%"
                : "15%",
            paddingRight:
              deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                ? "5%"
                : 0,
          }}
        >
          {" "}
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? AppFontStyle.BOLD_ANYBODY_25
                : AppFontStyle.BOLD_ANYBODY_32,
              {
                color: AppColors.white,
                marginVertical: 15,
                ...(deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                  ? { marginTop: 30 }
                  : {}),
              },
            ]}
          >
            Reset Password
          </Text>
          <View>
            {/* Auth Type Toggle */}
            <TouchableOpacity
              style={{ alignSelf: 'flex-end', marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}
              onPress={() => setAuthType(authType === 'phone' ? 'email' : 'phone')}
            >
              {authType === 'phone' ? (
                <Image
                  source={require('../../../../assets/auth/use-email-register.svg')}
                  style={{ width: 18, height: 18, marginRight: 6 }}
                  resizeMode="contain"
                />
              ) : (
                <Text style={{ marginRight: 6, fontSize: 16 }}>📱</Text>
              )}
              <Text style={{ color: '#DC2626', fontSize: 14, fontWeight: '800', lineHeight: 24 }}>
                {authType === 'phone' ? 'Use Email/Username' : 'Use Mobile'}
              </Text>
            </TouchableOpacity>

            {/* Conditional: Phone Number or Email/Username Input */}
            {authType === 'phone' ? (
              <View style={{
                flexDirection: 'row',
                marginBottom: 10,
                borderRadius: 8,
                backgroundColor: AppColors.appGrayColor_1C1C1C,
                overflow: 'hidden',
                height: 48,
                position: 'relative',
              }}>
                {/* Country Code Dropdown */}
                <View style={{
                  justifyContent: 'center',
                  borderRightWidth: 1,
                  borderRightColor: '#374151',
                  paddingHorizontal: 4,
                }}>
                  <select
                    style={{
                      height: '100%',
                      paddingLeft: 8,
                      paddingRight: 4,
                      background: '#1F2937',
                      border: 'none',
                      color: '#FFFFFF',
                      fontSize: 12,
                      fontFamily: 'Anybody_400Regular',
                      outline: 'none',
                      cursor: 'pointer',
                    }}
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                  >
                    {countryCodes.map((item, index) => (
                      <option key={index} value={item.code} style={{ backgroundColor: '#1F2937', color: '#FFFFFF' }}>
                        {item.code} {item.country}
                      </option>
                    ))}
                  </select>
                </View>
                {/* Phone Input */}
                <TextInput
                  style={{
                    flex: 1,
                    paddingHorizontal: 12,
                    paddingRight: 30,
                    color: AppColors.white,
                    fontSize: 12,
                    fontFamily: 'Anybody_400Regular',
                  }}
                  placeholder="Phone Number"
                  placeholderTextColor={AppColors.white}
                  value={phoneNumber}
                  onChangeText={(text) => setPhoneNumber(text.replace(/[^0-9]/g, ''))}
                  keyboardType="phone-pad"
                  maxLength={15}
                />
                {/* Asterisk indicator */}
                <View style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  bottom: 0,
                  justifyContent: 'center',
                  paddingTop: 5,
                  paddingRight: 10,
                }}>
                  <Text style={[AppFontStyle.REGULAR_ANYBODY_30, { color: AppColors.white }]}>*</Text>
                </View>
              </View>
            ) : (
              <CommonTextInputWeb
                placeholder="Email or Username"
                mainStyle={[styles.inputStyle]}
                inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
                prefixIconVisibility={false}
                onChangeText={setUsername}
                isPassword={false}
                value={username}
                onSubmitEditing={() => {
                  Keyboard.dismiss();
                }}
                autoCapitalize="none"
                maxLength={50}
                isRequired={true}
              />
            )}

            {/* Send Request */}
            <View
              style={{
                alignItems: "center",
              }}
            >
              {/* Send Request */}

              <TouchableOpacity
                style={{
                  width: "58%",
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: AppColors.buttonRed_DC2626,
                  borderRadius: 20,
                  marginVertical: 10,
                }}
                onPress={async () => {
                  if (checkValidation()) {
                    const param = authType === 'phone'
                      ? {
                        phoneNumber: `${countryCode}${phoneNumber}`,
                        authType: 'phone',
                      }
                      : {
                        username: username,
                        authType: 'email',
                      };

                    try {
                      setShowLoader(true);

                      const data = await resetPassword(param);

                      if (data.statusCode === 200 || data.statusCode === 201) {
                        toast.success(data.body.message || "OTP sent successfully");
                        navigateToScreen(navigation, AppScreens.ResetSetPasswordWebScreen, {
                          username: authType === 'phone' ? `${countryCode}${phoneNumber}` : username,
                          phoneNumber: authType === 'phone' ? `${countryCode}${phoneNumber}` : undefined,
                          authType: authType,
                        });
                      } else {
                        toast.error(data.body.error || "Reset Password Failed");
                      }
                    } catch (error) {
                      toast.error(error.message);
                    } finally {
                      setShowLoader(false);
                    }
                  }
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { color: AppColors.white },
                  ]}
                >
                  Send Request
                </Text>
              </TouchableOpacity>

              {/* Go back to login */}
              <TouchableOpacity
                style={{
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 20,
                }}
                onPress={() => {
                  navigateToScreen(navigation, AppScreens.LoginWebScreen);
                }}
              >
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_12,
                    { color: AppColors.white },
                  ]}
                >
                  Go back to login
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
      {deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.MD ||
        deviceSize === DEVICE_SIZES.LG ? null : (
        <View
          style={[
            {
              position: "relative",
              justifyContent: "center",
              alignItems: "center",
              paddingRight: "5%",
              flex: 0.6,
            },
          ]}
        >
          <View
            style={{
              borderRadius: 12,
              elevation: 20,
            }}
          >
            <Image
              source={AppImages.icMainLogo}
              style={{
                width: 764,
                height: 468,
              }}
              resizeMode="contain"
            />
          </View>
          <View
            style={{
              flexDirection: "row",
              position: "absolute",
              bottom: 20, // Adjust this for vertical alignment
              right: 30, // Adjust this for horizontal alignment
              alignItems: "center",
            }}
          >
            {/* YouTube logo */}
            <Image
              source={AppImages.icYoutubeLogo}
              style={{
                width: 56, // Set specific width and height instead of percentage
                height: 56,
              }}
              resizeMode="contain"
            />

            {/* Twitch logo */}
            <Image
              source={AppImages.icTwitchLogo}
              style={{
                width: 56,
                height: 56,
              }}
              resizeMode="contain"
            />
          </View>
        </View>
      )}
      <View
        style={{
          flexDirection: "row",
          position: "absolute",
          bottom: 20,
          right: 30,
          alignItems: "center",
        }}
      >
        <Image
          source={AppImages.icYoutubeLogo}
          style={{
            width: 56,
            height: 56,
          }}
          resizeMode="contain"
        />
        <Image
          source={AppImages.icTwitchLogo}
          style={{
            width: 56,
            height: 56,
          }}
          resizeMode="contain"
        />
      </View>
      {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
    </View>
  );
  function checkValidation() {
    if (authType === 'phone') {
      const digitsOnly = phoneNumber.replace(/\D/g, '');
      if (phoneNumber === "") {
        toast.error("Please Enter Phone Number");
        return false;
      }
      if (digitsOnly.length < 7) {
        toast.error("Phone number is too short. Please enter a valid phone number.");
        return false;
      }
      if (digitsOnly.length > 10) {
        toast.error("Phone number is too long. Please enter up to 10 digits (without country code).");
        return false;
      }
    } else {
      if (username === "") {
        toast.error("Please Enter Username or Email");
        return false;
      }
    }
    return true;
  }
};

export default ResetPasswordWebScreen;

const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 30,
    // overflow: "hidden",
    // width: '100%'
  },
  inputStyle: {
    backgroundColor: AppColors.appGrayColor_1C1C1C,
    marginBottom: 10,
  },
  textInputContainer: {
    height: 40,
  },
  roundedTextInput: {
    borderRadius: 10,
    borderWidth: 1,
    borderBottomWidth: 1,
    alignContent: "center",
    backgroundColor: AppColors.appBlueColor_3A5175,
    fontSize: 16,
    color: AppColors.white,
    elevation: 2,
    width: 40,
    height: 40,
  },
});
